import axios from 'axios';
import { v2Api, API_ROOT } from './v2Client';
import { ensureAccessToken } from './authTokens';
import { clubRequestHeaders } from '../currentClub';

function normArr(data) {
  return Array.isArray(data) ? data : [];
}

async function post(path, payload) {
  const { data } = await v2Api.post(path, payload);
  return data;
}

export const homeHighlightService = {
  list: () => post('/HomeHighlight/list', {}).then(normArr),
  get: (id) => post('/HomeHighlight/get', { id }),
  create: (payload) => post('/HomeHighlight/create', payload),
  update: (payload) => post('/HomeHighlight/update', payload),
  remove: (id) => post('/HomeHighlight/delete', { id }),
  reorder: (orderedIds) => post('/HomeHighlight/reorder', { orderedIds }),
  uploadImage: async (id, file) => {
    const fd = new FormData();
    fd.append('id', id);
    fd.append('file', file);
    const access = await ensureAccessToken(API_ROOT);
    const headers = clubRequestHeaders();
    if (access) headers.Authorization = `Bearer ${access}`;
    const { data } = await axios.post(`${API_ROOT}/HomeHighlight/upload_custom_image`, fd, {
      headers,
      maxContentLength: 12 * 1024 * 1024,
      maxBodyLength: 12 * 1024 * 1024,
    });
    return data;
  },
  clearImage: (id) => post('/HomeHighlight/clear_custom_image', { id }),
};
